<template>
  <router-view />
</template>

<script>
export default {
  name: 'EingangsrechnungenLayout',
};
</script>

<style></style>
